import io from 'socket.io-client';
import { SOCKET_MESSAGE_TYPES, API_ROOT_URL, BASE_COIN_SYMBOL} from '../constants/config';

let socket = null

export const init = ( token, merchantAccountAddress, store ) => {
  // auth and personalise the socket for the client

  let data = {
    baseCoinSymbol: BASE_COIN_SYMBOL,
    merchantAccountAddress: merchantAccountAddress
  }

  let socketQuery = { 
    token: token,
    applicationId: 3,
    data: JSON.stringify(data)
  }

  // init the sockey
  socket = io( `${API_ROOT_URL}`, { secure: true, query: socketQuery });
  
  //create message types for each required channel for the client
  Object.keys( SOCKET_MESSAGE_TYPES )
    .forEach( type => socket.on( type, ( payload ) => 
       store.dispatch({ type, payload }) 
    )
  );
};
export const emit = ( type, payload ) => socket.emit( type, payload );